/* tslint:disable */

/**
 */
export class UserUpdate {
    fullname?: string;
    id?: number;
    company_id?: number;
    rfid?: string;
    username?: string;
    email?: string;
    role_id?: number;
    birthday?: string;
    address?: string;
    sidn?: string;
    gender?: number;
    phone?: string;
    ticket_counters_data?: number[];
    single_online?: boolean;
    is_online?: boolean;
    einvoice?: boolean;
    einvoice_data?: {
        buyername?: string;
        taxcode?: string;
        email?: string;
        emailcc?: string;
        address?: string;
    };
}
